import * as React from "react";
import type { SVGProps } from "react";
const SvgMagazine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#magazine_svg__a)">
      <path d="M12 22c-.12 0-.25-.02-.37-.07-2.66-1.06-5.6-1.06-8.26 0-.31.12-.66.08-.93-.1-.27-.19-.44-.5-.44-.83V7a1 1 0 0 1 .63-.93c.59-.24 1.17-.36 1.73-.47l.38-.08a1.003 1.003 0 0 1 .42 1.96l-.4.08c-.26.05-.51.11-.76.17v11.88a13 13 0 0 1 7 0V7c0-.55.45-1 1-1s1 .45 1 1v14a1 1 0 0 1-1 1" />
      <path d="M12 22c-.26 0-.51-.1-.7-.29-2.45-2.42-4.69-3.88-6.49-4.23A1 1 0 0 1 4 16.5V3a.992.992 0 0 1 1.19-.98c2.37.46 5.04 2.06 7.51 4.51a1 1 0 0 1 .3.71V21c0 .4-.24.77-.62.92-.12.05-.25.08-.38.08m-6-6.28c1.54.48 3.21 1.48 5 3V7.66c-1.68-1.6-3.41-2.75-5-3.34z" />
      <path d="M21 22c-.12 0-.25-.02-.37-.07-2.66-1.06-5.6-1.06-8.26 0-.31.12-.66.08-.93-.1-.27-.19-.44-.5-.44-.83V7c0-.55.45-1 1-1s1 .45 1 1v12.61a13 13 0 0 1 7 0V7.73c-.24-.06-.5-.11-.76-.17l-.4-.08a1.01 1.01 0 0 1-.77-1.19c.12-.54.65-.88 1.19-.77l.38.08c.56.11 1.13.23 1.73.47A1 1 0 0 1 22 7v14a1 1 0 0 1-1 1" />
      <path d="M12 22a1.013 1.013 0 0 1-1-1V7.24a1 1 0 0 1 .3-.71c2.47-2.45 5.14-4.06 7.51-4.51A.992.992 0 0 1 20 3v13.5c0 .48-.34.89-.81.98-1.8.35-4.04 1.81-6.49 4.23-.19.19-.45.29-.7.29m1-14.34v11.06c1.79-1.52 3.46-2.52 5-3V4.32c-1.59.59-3.32 1.74-5 3.34" />
    </g>
    <defs>
      <clipPath id="magazine_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMagazine;
